import request from '@/api/request'
// 获取学时详情页数据
export function geoSearchApi(address:any){
    let url = '/api/manager/geo/search';

    let data = {
        address
    }

    return request({
        url: url,
        method: 'post',
        data
    })
}


